import * as z from "zod";
import { requiredErrorMessage } from "../common/error-messages";
import { SUPPORT_REPORT_KIND_OPTIONS } from "@/constants/support/support-constants";

export const supportReportSchema = z.object({
  kind: z.enum(SUPPORT_REPORT_KIND_OPTIONS.map((option) => option.value)),
  message: z
    .string()
    .trim()
    .min(1, requiredErrorMessage)
    .max(1000, "Please keep it under 1000 characters."),
});
